/**
 * Media query's breakpoints
 * 320, 420, 768, 1024, 1200
 * See $breakpoints map in scss variables
 */

export enum MediaQueries {
    maxSmallBP = '(max-width: 767px)',
    touchMotionSensor = '(pointer: coarse)',
    mouseStylus = '(pointer: fine)',
    hover = '(hover: hover)',
    reduceMotion = '(prefers-reduced-motion: reduce)',
    reduceData = '(prefers-reduced-data: reduce)'
}
/**
 * The Window interface represents a window containing a DOM document
 * https://developer.mozilla.org/en-US/docs/Web/API/Window
 */
export class WindowUtils {
    /**
     * determine if the Document matches the media query
     * method to determine if "mobile" max 767 breakpoint
     */
    static get isMobileBreakpointDown(): boolean {
        return window.matchMedia(MediaQueries.maxSmallBP).matches
    }

    /**
     * determine if device/browser matches the media query
     * method for having ability to touch
     */
    static get hasTouch(): boolean {
        const navigatorTouch =
            (navigator && navigator.maxTouchPoints > 0) ||
            (navigator && navigator.msMaxTouchPoints > 0)

        return (
            window.matchMedia(MediaQueries.touchMotionSensor).matches ||
            'ontouchstart' in window ||
            navigatorTouch
        )
    }

    /**
     * @return MediaQueryList (properties, methods, events)
     * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
     */
    static get reduceMotionQueryList(): MediaQueryList {
        return window.matchMedia(MediaQueries.reduceMotion)
    }

    /**
     * determine if device/browser matches the media query
     * method for user preferring less motion
     */
    static get reduceMotion(): boolean {
        return window.matchMedia(MediaQueries.reduceMotion).matches
    }
}
